// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { ModulationsSummary } from '../../common'

const FormatThroughput = ({ columnKey, rowData }) => {
  const { radioCode } = rowData
  const modulations = rowData[columnKey]

  // if there's only one modulation, just show its throughput
  if (modulations.length === 1) {
    return modulations[0].throughput
  }

  // otherwise display the modulations tooltip from project summary screen.
  const tooltipContent = () => <ModulationsSummary modulations={modulations} />

  return (
    <div className={'display-flex justify-content-start align-items-center'}>
      <p
        className={'tooltip-trigger-decoration show-decoration acm-tooltip-decoration'}
        data-class={'project-summary-tooltip tooltip-wrapper'}
        data-for={`lookup-tooltip-radio-modulations-${radioCode}`}
        data-tip={true}
        id={`lookup-tooltip-radio-modulations-${radioCode}-trigger`}>
        {'ACM'}
      </p>
      <ReactTooltip
        delayHide={200}
        effect={'solid'}
        id={`lookup-tooltip-radio-modulations-${radioCode}`}
        getContent={tooltipContent}
        place={'bottom'}
        type={'light'} />
    </div>
  )
}

FormatThroughput.propTypes = {
  columnKey: string.isRequired,
  rowData: object.isRequired,
}

export default FormatThroughput
